import React, { useState } from 'react'
import ProfileNavbar from '../../../../components/Profile-navbar/profile-navbar'
import './jobs.css'
import savedJobs from '../../../../images/saved-jobs.svg'
import archivedJobs from '../../../../images/archivedJobs.svg'
import favorite from '../../../../images/favorite.svg'
import dot from '../../../../images/dot.svg'
import { Link } from 'react-router-dom'
import { FaArrowRight } from 'react-icons/fa'
import { appliedJobs } from '../../../../data'
import { interviewJobs } from '../../../../data'
import { recommendedJobs } from '../../../../data'
import { Container, Row, Col, Button, Card } from 'react-bootstrap'


const Jobs = () => {
  const [selectedButton, setSelectedButton] = useState(0);

  const handleButtonClick = (buttonIndex) => {
    setSelectedButton(buttonIndex);
  };
  
  return (
    <div>
       <ProfileNavbar/>
       <Container fluid className='p-1 p-md-5 '>
       <h1 className='mt-3 p-3 jobs-header'>My Jobs</h1>
       <div className='d-block d-md-none mt-4'>
          <div className='d-flex gap-sm-5'>
            <button className={selectedButton === 0 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(0)}>
            Saved
            </button>
            <button className={selectedButton === 1 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(1)}>
            Applied
            </button>
            <button className={selectedButton === 2 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(2)}>Interviews
            </button>
            </div> 
            <div className='d-flex gap-sm-5 mt-sm-3 '> 
            <button className={selectedButton === 3 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(3)}>Recommended
            </button>
            <button className={selectedButton === 4 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(4)}>Archived</button>
            </div> 
           </div>
       <div className='d-md-flex d-none gap-lg-5 gap-md-3 mt-5 align-items-center justify-content-center'>
            
            <button className={selectedButton === 0 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(0)}>
            Saved
            </button>
            <button className={selectedButton === 1 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(1)}>
            Applied
            </button>
            <button className={selectedButton === 2 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(2)}>Interviews
            </button>
            <button className={selectedButton === 3 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(3)}>Recommended
            </button>
            <button className={selectedButton === 4 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(4)}>Archived</button>
            
           </div>
        <div className='py-5 px-2'>
        {selectedButton === 0 && (
              <div className="">
                <div className='d-flex flex-column  align-items-center gap-2 saved-information'>
                  <img src={savedJobs}/>
                  <h5> No saved jobs yet</h5>
                  <p>Your saved jobs will appear here</p>
                </div>
                <div className='d-flex justify-content-end mt-5'>

                  <div>  
                    <Link to='/find' className='btn-1 btn-1-primary'>Find jobs <FaArrowRight/></Link>
                  </div>
                </div>
              </div>
        )}      

        {selectedButton === 1 && (
              <div className="py-4 px-2 ">
                {appliedJobs.map((applied) =>{
                  const {id,role,companyName,image,location,dateApplied} = applied;
                  return(
                    <Card className='applied-card p-3 mb-3 border-0'>
                    <Row className='align-items-center gap-4'>
                      <Col  sm={4} md={3} lg={3} xl={2} >
                      <img src={image} style={{ width:'180px', height:'100px'}}/>
                      </Col>
                      <Col className='d-flex flex-column gap-2 applied-info '>
                      <h4>{role}</h4>
                          <h5>{companyName}, &nbsp; <span>{location}</span></h5>
                          <p>{dateApplied}</p>
                      
                      </Col>
                      <Col xs={1} className='justify-content-center align-items-center text-center'>
                      <img src={dot}/>
                      </Col>
                    </Row>
  
                  </Card>
                  )
                })}
              </div>
        )}

        {selectedButton === 2 && (
              <Row className="py-4 px-2">
               {
                interviewJobs.map((interview) => {
                  const {id,
                    image,
                    role,
                    company,
                    amount,
                    frequency,
                    period,
                    workMode,
                    icon,
                    date,
                    time,
                    venue} = interview;
                    return(
                     <Col xs={12} lg={6} className='mb-3'>
                      
                        <Card className=' p-3 border-0' style={{background: '#F5F8FD', height:'100%'}}>
                            <Row style={{flex: 1}}>
                              
                              <Col xl={2} lg={12} md={2} xs={12}className='pb-3'>
                              <img className='companyImg' src={image}/>
                              </Col>
                              <Col xl={5} lg={6} md={5} sm={6} xs={12}className='d-flex flex-column gap-2 role-details ms-xl-2 '>
                              
                              <h2>{role}</h2>
                              <h4>{company}</h4>
                              <p>{amount} &nbsp; <span>({frequency})</span></p>
                              <div className='d-flex gap-xl-4 gap-lg-2 gap-md-4 gap-4 align-items-center'>
                                <button className='period-btn'>{period}</button>
                            
                                <p> <img src={icon}/> &nbsp;{workMode}</p>
                             </div>
                            
                              
                              </Col>
                              <Col xl={4} lg={6} md={5} sm={6} xs={12}className='d-flex flex-column  interview-details mt-2 mt-sm-0'>
                              <h3>Interview Details</h3>
                          <p>Date: &nbsp; <span>
                          {date}</span></p>
                          <p>Time: &nbsp; <span>
                          {time}</span></p>
                          <p>Venue: &nbsp; <span>
                          {venue}</span></p>
                              </Col>
                          </Row>
                          <div className='d-flex align-items-center justify-content-center'>
                          <button className='chat-btn'>Chat with Employer</button>
                          </div>
                        </Card>
                     </Col>
                    )
                  }
                )
               }
              </Row>
              )}

        {selectedButton === 3 && (
              <Row className="py-4 px-2">
                {recommendedJobs.map((jobs) => {
                   const {id,
                    image,
                    role,
                    company,
                    amount,
                    frequency,
                    period,
                    workMode,
                    icon,
                    } = jobs;
                    return(
                        <Col lg={4} md={6} xs={12} className='mb-3'>
                        <Card className='p-3 border-0' style={{background: '#F5F8FD', height:'100%'}} >
                        <div style={{flex:1}}>
                        <div className='d-flex gap-3'>
                            <img src={image} style={{width: '53px',height: '53px'}}/>
                            <div className='d-flex align-items-center gap-5'>
                              <button className='period-btn'>{period}</button>
                              <p className='remote'> <img src={icon}/>{workMode}</p>
                            </div>
                        </div>
                        <div className='d-flex flex-column  recommend-details mt-2'>
                        <h4>{role}</h4>
                            <p>{company}</p>
                            <h6>{amount}&nbsp;<span>({frequency})</span></h6>
                        </div>
                        </div>
                        <div className='d-flex align-items-center justify-content-center gap-3 mt-4'>
                        <button className='apply-btn'>Apply</button>
                            <button className='save-btn'><img src={favorite}/>
                              Save</button>
                        </div>
                        
                        </Card>
                        
                        </Col>
                    )
                  
                    
                })}
              </Row>
              )}

        {selectedButton === 4 && (
              <div className="">
                <div className='d-flex flex-column  align-items-center gap-2 saved-information'>
                  <img src={archivedJobs}/>
                  <h5> No archived jobs yet</h5>
                  <p>Your archived jobs will appear here</p>
                </div>
                <div className='d-flex justify-content-end mt-5'>

                  <div>  
                    <Link to='/find' className='btn-1 btn-1-primary'>Find jobs <FaArrowRight/></Link>
                  </div>
                </div>
              </div>
        )}  
        </div>


       </Container>
        
    </div>
  )
}

export default Jobs
